import { render, staticRenderFns } from "./CancelBooking.vue?vue&type=template&id=6cb636b8"
import script from "./CancelBooking.vue?vue&type=script&lang=js"
export * from "./CancelBooking.vue?vue&type=script&lang=js"
import style0 from "./CancelBooking.vue?vue&type=style&index=0&id=6cb636b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports